// extracted by mini-css-extract-plugin
export default {"form-field":"CustomerAddressInfo-module__form-field--fAN8j","address":"CustomerAddressInfo-module__address--wNaiq"};